import React, { useState } from 'react'

import { List, Typography, Button } from 'antd'
import gql from 'graphql-tag'
import PT from 'prop-types'

import ConfirmModal from '../../../../../ConfirmModal'
import { removeAdminsFromList } from '../utils'

const TeamInfo = props => {
  const { admins, onDelete, refetchTeams, team } = props
  const { id, name, members, updatedAt } = team

  const [deleteModalVisible, setDeleteModalVisible] = useState(false)

  const regularMembers = removeAdminsFromList(members, admins)

  const onDeleteTeam = async () => {
    await onDelete(id)
    refetchTeams()
    setDeleteModalVisible(false)
  }

  return (
    <List.Item
      className="team-info-panel-header"
      actions={[
        <>
          <Button
            ghost
            icon="delete"
            onClick={() => setDeleteModalVisible(true)}
            size="small"
            style={{ marginLeft: 10 }}
            type="danger"
            aria-label={`Delete team ${name}`}
          >
            Delete
          </Button>
          <ConfirmModal
            okButtonProps={{ disabled: regularMembers.length > 0 }}
            onCancel={() => setDeleteModalVisible(false)}
            onConfirm={onDeleteTeam}
            title="Are you sure you want to delete this team?"
            visible={deleteModalVisible}
          >
            {regularMembers.length > 0 && (
              <Typography.Text type="danger">
                Please reassign or remove users from this team before deleting it.
              </Typography.Text>
            )}
          </ConfirmModal>
        </>,
      ]}
    >
      <div className="ant-list-item-meta">
        <div className="ant-list-item-meta-content">
          <h3 className="ant-list-item-meta-title">{name}</h3>
          <div className="ant-list-item-meta-description">{`Last updated: ${updatedAt}`}</div>
        </div>
      </div>
      <div>
        {`${regularMembers.length} ${regularMembers.length === 1 ? 'user' : 'users'}`}
      </div>
    </List.Item>
  )
}

TeamInfo.fragments = gql`
  fragment universityClientTeamFields on UniversityClientTeam {
    id
    name
    updatedAt(format: "lll")
    members {
      id
      email
      teams {
        id
      }
    }
    documentPermissions {
      id
      document {
        id
      }
      permissions
    }
    reportPermissions {
      id
      report {
        id
      }
      permissions
    }
  }
`

TeamInfo.propTypes = {
  admins: PT.array.isRequired,
  allTeams: PT.array.isRequired,
  documents: PT.array.isRequired,
  onDelete: PT.func.isRequired,
  onEditTeamSubmit: PT.func.isRequired,
  onReassignTeamSubmit: PT.func.isRequired,
  refetchTeams: PT.func.isRequired,
  reports: PT.array.isRequired,
  tags: PT.object.isRequired,
  team: PT.object.isRequired,
}

export default TeamInfo
